export default __webpack_public_path__ + "static/media/icon-logo-remar.a4da5ee9.svg";